import Component from '@glimmer/component';
import { action } from '@ember/object';
import type ThemeModel from 'scaleflow/models/theme';
import type GoalModel from 'scaleflow/models/goal';
import type InitiativeModel from 'scaleflow/models/initiative';

export interface RoadmapCardSignature {
  // The arguments accepted by the component
  Args: {
    group: {
      theme: ThemeModel;
      initiatives: InitiativeModel[];
      goals: GoalModel[];
    };
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class RoadmapCard extends Component<RoadmapCardSignature> {
  @action
  statusDotColor(initiative: InitiativeModel) {
    if (initiative.status === 'COMPLETED') return 'bg-green-600';
    if (
      initiative.openWfas.length ||
      initiative.unarchivedUncertaintiesDetailed.open
    )
      return 'bg-purple-600'; //Blockers
    if (initiative.status === 'ACTIVE') return 'bg-primary-600';
    return 'bg-gray-100';
  }
}
